import React, { useState } from 'react';

import { doAjax } from 'newJs/utils';

const usePdfFile = (link, baseUrl) => {
    const [data, setData] = useState(null);
    const [loadingState, setLoadingState] = useState(false);
    const url = baseUrl + link;

    React.useEffect(() => {
        setLoadingState('loading');

        doAjax({
            url,
            xhr: () => {
                // Seems like the only way to get access to the xhr object
                const xhr = new XMLHttpRequest();
                xhr.responseType = 'blob'; // !!! Important
                return xhr;
            },
            success: function (data) {
                setData(data);
                setLoadingState('loaded');
            },
            error: (/* err */) =>{
                // console.log(err);
            }
        });
    }, [url]);

    return [data, loadingState];
};

export default usePdfFile;
